var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var editor_2d = require("editor-2d");
var PlacingStateMachine = editor_2d.PlacingStateMachine;

var PropertyToolStateMachine = function (root, editorModel, selectionModel, getDataCollection, options) {
    this.root = root;
    this.getDataCollection = getDataCollection;
    this.options = options;

    PlacingStateMachine.call(this, root, editorModel, selectionModel, this.options.multiplePlacing);
};

lib_core.inherit(PropertyToolStateMachine, PlacingStateMachine);

module.exports = PropertyToolStateMachine;

PropertyToolStateMachine.prototype.createElement = function(startCoord) {
    var text = new cio_datamodel.TextData(startCoord, 0, undefined, this.options.font, this.options.fontSize, this.options.fontUnit);
    var propertyData = new cio_datamodel.PropertyData(text);
    var propertyLayerdShapeData = new cio_datamodel.LayeredShapeData(propertyData, 0);

    propertyLayerdShapeData.addTo(this.getDataCollection());

    return this.editorModel.interactionModelDataMap.get(propertyLayerdShapeData);
};

